import { scenes } from "../scenes";
import { Scene, Dialog } from "../models";

const tvNews = require("@/images/TV_News.png");
const tvAnchor = require("@/images/TV_Anchor.png");
const yoghurt = require("@/images/TV_Yoghurt.png");
const doctors = require("@/images/TV_Doctors.png");
const sonny = require("@/images/sonny.png");
const introDialog = [
  new Dialog("[BREAKING NEWS THEME!]", tvNews, require("@/audio/Placeholder-music.mp3")),
  new Dialog(
    "NEWS ANCHOR: Bill Nuckman here, bringing you an emergency news bulletin. The World Health Organisation has declared a global pandemic crisis with the outbreak of YOGID - 19",
    tvAnchor,
    require("@/audio/Pandemic-1-Newscaster1.mp3")
  ),
  new Dialog(
    "NEWS ANCHOR: ...a virus speculated to have been caused by someone eating some bad yoghurt.",
    yoghurt,
    require("@/audio/Pandemic-1-Newscaster2.mp3")
  ),
  new Dialog(
    "NEWS ANCHOR: The Government has issued a statement urging the general populace to panic and hoard as much food and supplies as they can in preparation for a complete societal lockdown. Local authorities advice a hard and fast approach when stocking up at the supermarket... push old and vunerable people out...",
    doctors,
    require("@/audio/Pandemic-1-Newscaster3.mp3")
  ),
  new Dialog(
    "SONNY YANG: Egads! Looks like I’d better get myself down to the SUPERMARKET.",
    sonny,
    require("@/audio/Pandemic_2_Sonny-MP3.mp3")
  ),
];

export class Introduction extends Scene {
  description: string = "";
  isFullscreen = true;
  title = "Introduction"
  timer: number = 0;
  encodedImage = null;
  async init() {
    await this.dialogRunner(introDialog)
    await this.navigate(scenes.TitleScene());
  }
}

export default new Introduction();
